import { Authorizations } from "~/api/types";

type WithAuthorizations<R extends object, T extends string> = {
  record: R;
  can: Record<T, boolean>;
};

export class MemberAuthorizationsResolver<R extends object, T extends string> {
  constructor(private readonly authorizedActions: T[]) {}

  getRequestHeaders(): HeadersInit {
    return {
      "Authorize-Member-Actions": this.authorizedActions.join(","),
    };
  }

  resolveAuthorizations(
    records: R[],
    authorizations?: Authorizations,
  ): WithAuthorizations<R, T>[] {
    const memberAuthorizations = authorizations?.member ?? [];

    return records.map((record, index) => ({
      record,
      can: Object.fromEntries(
        this.authorizedActions.map((action) => [
          action,
          memberAuthorizations[index].includes(action),
        ]),
      ) as Record<T, boolean>,
    }));
  }
}

export type InferResolvedRecordType<M> =
  M extends MemberAuthorizationsResolver<infer R, infer T>
    ? {
        record: R;
        can: Record<T, boolean>;
      }
    : never;
